import React from 'react';
import Table from 'react-bootstrap/Table';
import TableHeaderReporting from './TableHeaderReporting';
import TableBodyReporting from './TableBodyReporting';
import { IGetReportingResponse } from '../../../interfaces/api/IEmails';

export default function TableReporting({data} : { data: IGetReportingResponse  }) {
    return (
        <div className='table-container'>
            <Table className='table list reporting'>
                <TableHeaderReporting />
                <TableBodyReporting data={data} />
            </Table>
        </div>
    );
}